"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logIn = exports.SET_USER_LOGIN = exports.logOut = exports.USER_LOGOUT = exports.setOAuthState = exports.SET_OAUTH_STATE = void 0;

var _reduxBatchedActions = require("redux-batched-actions");

var _createAction = require("skybase-ui/skybase-core/base/create-action");

var _getActionName = require("skybase-ui/skybase-core/utils/get-action-name");

var _constants = require("./constants");

var _constants2 = require("../constants");

var SET_OAUTH_STATE = (0, _getActionName.getActionName)('SET_OAUTH_STATE', _constants2.MODULE_NAME);
exports.SET_OAUTH_STATE = SET_OAUTH_STATE;

var setOAuthState = function setOAuthState(state) {
  return (0, _createAction.createAction)(SET_OAUTH_STATE, {
    state: state
  });
};

exports.setOAuthState = setOAuthState;
var USER_LOGOUT = (0, _getActionName.getActionName)('USER_LOGOUT', _constants2.MODULE_NAME);
exports.USER_LOGOUT = USER_LOGOUT;

var logOut = function logOut() {
  return function (dispatch) {
    dispatch((0, _reduxBatchedActions.batchActions)([setOAuthState(_constants.oAuthStates.LOGGING_OUT), (0, _createAction.createAction)(USER_LOGOUT)]));
  };
};

exports.logOut = logOut;
var SET_USER_LOGIN = (0, _getActionName.getActionName)('SET_USER_LOGIN', _constants2.MODULE_NAME);
exports.SET_USER_LOGIN = SET_USER_LOGIN;

var logIn = function logIn(user) {
  return (0, _createAction.createAction)(SET_USER_LOGIN, {
    user: user
  });
};

exports.logIn = logIn;
//# sourceMappingURL=actions.js.map